import React, { useEffect, useState } from 'react';

import { Colors } from '@zapier/design-system';

import Meter from 'app/developer-v3/components/Meter';

import type { PartnerUsageHealthScoreType } from 'app/developer-v3/types/partnerDashboard';

const CHARACTERISTICS = {
  EXCEPTIONAL: { color: Colors.Blue3, percent: 100 },
  HEALTHY: { color: Colors.StatusSuccessStrongest, percent: 70 },
  NA: { color: null, percent: 50 },
  POOR: { color: Colors.Red4, percent: 10 },
};

type Props = {
  score: PartnerUsageHealthScoreType;
  height?: number;
  width?: number;
};

function HealthScoreMeter(props: Props) {
  const { score, height, width } = props;
  const [barColor, setBarColor] = useState(undefined);
  const [percent, setPercent] = useState<number>(0);

  const meterProps = {
    barColor,
    percent,
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      const characteristics = CHARACTERISTICS[score];
      setBarColor(characteristics.color);
      setPercent(characteristics.percent);
    }, 1000);
    return () => clearTimeout(timer);
  }, [score]);

  return <Meter height={height} width={width} {...meterProps} />;
}

export default HealthScoreMeter;
